import React from "react";
import { Link } from "react-router-dom";

const AboutOne = () => {
  return (
    <div className="about-area-1 space-bottom">
      {/* Imágenes de fondo y formas decorativas */}
      <div className="about1-shape-img shape-mockup">
        <img
          className="about1-shape-img-1 spin"
          src="/assets/img/normal/about_shape1-2.svg"
          alt="Leal Chapa y Pintura"
        />
        <img
          className="about1-shape-img-2 spin2"
          src="/assets/img/normal/about_shape1-1.svg"
          alt="Leal Chapa y Pintura"
        />
      </div>

      <div className="container">
        <div className="row gx-60 align-items-center">
          {/* Sección de imágenes */}
          <div className="col-xl-6">
            <div className="about-thumb1 mb-40 mb-xl-0">
              <div className="about-img-1">
                {/* Reemplaza estas rutas con tus propias imágenes */}
                <img
                  src="/assets/img/normal/about_1-1.png"
                  alt="Leal Chapa y Pintura"
                />
              </div>
              <div className="about-img-2">
                <img
                  src="/assets/img/normal/about_1-2.png"
                  alt="Leal Chapa y Pintura"
                />
              </div>
            </div>
          </div>

          {/* Sección de texto */}
          <div className="col-xl-6">
            <div className="about-content-wrap">
              <div className="title-area me-xl-5 mb-20">
                <span className="sub-title">Conócenos</span>
                <h2 className="sec-title">
                  Donde la experiencia se ve reflejada en cada detalle
                </h2>
                <p className="sec-text">
                  Con más de 15 años de trayectoria, en Leal Chapa y Pintura
                  combinamos dedicación, técnica y un profundo compromiso con la
                  calidad. Nuestro objetivo es brindarte el mejor servicio de
                  reparación y pintura para que tu vehículo luzca como nuevo.
                </p>
              </div>

              <div className="row gy-4 justify-content-xl-between justify-content-end align-items-center flex-row-reverse">
                {/* Sección de años de experiencia */}
                <div className="col-lg-auto">
                  <div className="about-year-wrap">
                    <div
                      className="about-year-mask-wrap"
                      style={{
                        maskImage: "url(/assets/img/bg/about_counter-bg1-1.png)",
                      }}
                    >
                      <img
                        src="/assets/img/icon/about_icon1-1.svg"
                        alt="Leal Chapa y Pintura"
                      />
                      <h3 className="about-year-wrap-title">
                        <span className="counter-number">15</span>
                      </h3>
                      <p className="about-year-wrap-text">
                        Años de experiencia
                      </p>
                    </div>
                  </div>
                </div>

                {/* Lista de servicios o características */}
                <div className="col-xl-auto col-lg-6">
                  <div className="checklist">
                    <ul>
                      <li>
                        <i className="fas fa-check-circle" />
                        Servicio profesional de chapa y pintura
                      </li>
                      <li>
                        <i className="fas fa-check-circle" />
                        Reparación integral de carrocería y detalle
                      </li>
                      <li>
                        <i className="fas fa-check-circle" />
                        Técnicas de pintura de alta calidad
                      </li>
                      <li>
                        <i className="fas fa-check-circle" />
                        Personal capacitado y atención personalizada
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Botón de "Leer más" (puedes cambiar la ruta /about a la que gustes) */}
              <div className="btn-wrap mt-20">
                <Link to="/nosotros" className="btn style2 mt-xl-0 mt-20">
                  Leer más <i className="fas fa-arrow-right ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOne;
